import React from 'react'
import assets from '../assets'
import './index.css'
import { motion } from 'framer-motion'

const Section6 = ({variants}) => {
  return (
    <div className='section extraPadTop syntheSec relative flex justifyCenter'>
        <img className='systemSmall' src={assets.light.section6} alt="System" />
        <div className="container-lg flex flexCol alignCenter relative">
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            >
              {assets.econCuadro}
            </motion.div>
            <motion.h3
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .5 }}
            viewport={{ once: true }}
            className='iconCorner textCenter width70 extraMbottom'>
                We bring a frictionless solution to instant <strong>synthetic assets listing</strong>, increased APY from original asset, automated programable cash flows and back end infrastructure. 
            </motion.h3>
            <motion.div
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .7 }}
            viewport={{ once: true }}>
              {assets.icons.synthe}
            </motion.div>
        </div>
    </div>
  )
}

export default Section6